import { Button, Flex, Tooltip } from 'antd';
import {
  CheckCircleOutlined,
  DownloadOutlined,
  EyeOutlined,
} from '@ant-design/icons';

const getTooltipText = (downloadComplete, totalDocuments) => {
  if (downloadComplete) {
    return `${totalDocuments} statements downloaded!`;
  }

  if (totalDocuments) {
    return `${totalDocuments} statements ready for download`;
  }

  return '';
};

export const RequestDownloadButton = ({
  currentDownloadRequest,
  downloadRequestId,
  queueDownloadLoading,
  requestDownload,
}) => {
  const downloadComplete = currentDownloadRequest.downloadComplete;

  const getButtonText = () => {
    if (downloadComplete) {
      return 'Download Complete';
    }

    if (downloadRequestId) {
      return 'Preparing Download...';
    }

    return 'Download Lifetime Statements';
  };

  return (
    <Tooltip
      title={getTooltipText(
        downloadComplete,
        currentDownloadRequest.totalDocuments,
      )}
    >
      <Button
        icon={downloadComplete && <CheckCircleOutlined />}
        style={{ height: '100%' }}
        onClick={requestDownload}
        loading={
          queueDownloadLoading || (downloadRequestId && !downloadComplete)
        }
        disabled={downloadComplete || downloadRequestId}
      >
        {getButtonText()}
      </Button>
    </Tooltip>
  );
};

export const ViewDownloadAndFailedDocumentsButtons = ({
  currentDownloadRequest,
  downloadUrl,
  failedDocumentsModal,
  handleDownloadComplete,
}) => {
  const downloadComplete = currentDownloadRequest.downloadComplete;

  return (
    <Flex justify="flex-end" gap="var(--spacing-sm)">
      <Tooltip
        title={getTooltipText(
          downloadComplete,
          currentDownloadRequest.totalDocuments,
        )}
      >
        <Button
          type="primary"
          icon={
            downloadComplete ? <CheckCircleOutlined /> : <DownloadOutlined />
          }
          disabled={downloadComplete}
          style={{ height: '100%' }}
          href={downloadUrl}
          download
          onClick={handleDownloadComplete}
        >
          {downloadComplete ? 'Download Complete' : 'Download'}
        </Button>
      </Tooltip>
      <Button
        danger
        ghost
        icon={<EyeOutlined />}
        style={{ height: '100%' }}
        onClick={failedDocumentsModal.show}
      >
        View Failed Documents
      </Button>
    </Flex>
  );
};
